<template>
  <div class="pa-10 d-flex flex-column">
    <h1 class="display-1 text-center mb-8">Covid Test</h1>

    <form
      class="personal-info d-flex flex-column flex-grow-1"
      @submit.prevent="submit"
    >
      <div class="subtitle-1 font-weight-bold mb-2">
        3. {{ $t("cellexTest.fourth.fourthTitle") }}
      </div>

      <v-radio-group
        v-model="isPositive"
        column
        dense
        :label="$t('cellexTest.fourth.resultsLabel')"
        class="align-self-start"
      >
        <v-radio
          :label="$t('cellexTest.fourth.positive')"
          value="positive"
          color="primary"
          :ripple="false"
        ></v-radio>
        <v-radio
          :label="$t('cellexTest.fourth.negative')"
          value="negative"
          color="primary"
          :ripple="false"
        ></v-radio>
        <v-radio
          :label="$t('cellexTest.fourth.unsure')"
          value="unsure"
          color="primary"
          :ripple="false"
        ></v-radio>
      </v-radio-group>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.fourth.temperatureLabel')"
        v-model="temperature"
      ></v-text-field>

      <v-text-field
        class="flex-grow-0"
        :label="$t('cellexTest.fourth.serialNumberLabel')"
        v-model="serialNumber"
      ></v-text-field>

      <v-radio-group label="Τύπος test" v-model="testType">
        <v-radio value="pcr" label="Pcr"></v-radio>
        <v-radio value="rapid" label="Rapid"></v-radio>
        <v-radio value="antigon" label="Αντιγόνου"></v-radio>
      </v-radio-group>

      <v-file-input
        :error-messages="fileErrors"
        v-model="file"
        label="Αρχείο pdf"
        accept="application/pdf"
      ></v-file-input>

      <v-btn
        color="primary"
        depressed
        class="align-self-center mt-auto"
        type="submit"
        >{{ $t("cellexTest.fourth.btn") }}</v-btn
      >
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      isPositive: "negative",
      temperature: "",
      serialNumber: "",
      file: null,
      testType: "pcr",
    };
  },
  methods: {
    ...mapActions(["newCellexTestFourth"]),
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.newCellexTestFourth({
          isPositive: this.isPositive,
          temperature: this.temperature,
          serialNumber: this.serialNumber,
          file: this.file,
          testType: this.testType,
        });
      }
    },
  },
  validations: {
    file: {
      required,
    },
  },
  computed: {
    fileErrors() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      if (!this.$v.file.required) errors.push("Υποχρεωτικό");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>